"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ShiftAttributes = void 0;
const react_1 = __importDefault(require("react"));
const i18n_1 = require("@app/util/i18n");
const _ui_1 = require("@ui");
const shift_attributes_1 = require("@app/util/shift-attributes");
const ShiftAttributes = ({ attributes }) => {
    return attributes?.length ? (react_1.default.createElement("div", { className: 'ds-viewshift-row' },
        react_1.default.createElement("div", { className: 'ds-viewshift-col-label' }, (0, i18n_1.t)('SHIFT_ATTRIBUTES_NAV_NAME')),
        react_1.default.createElement(_ui_1.Flex, { direction: _ui_1.Flex.DIRECTION.COLUMN }, attributes.map((attribute) => {
            return (react_1.default.createElement("span", { className: 'ds-viewshift-col-value', key: attribute.id }, (0, shift_attributes_1.formatAttributeName)({ attribute })));
        })))) : null;
};
exports.ShiftAttributes = ShiftAttributes;
